module.exports = __webpack_public_path__ + "static/media/scheduling.901c0848.svg";